<template>
	<AppDropdownMenu left bottom absolute min-width="560" max-width="560" content-class="men" :disabled="disabled" :items="items">
		<template #activator>
			<div class="selector" :class="{ 'is-disabled': disabled }">
				{{ disabled ? 'Admin' : selectedRole }}
				<div v-if="disabled" class="disabled-description is-disabled">Project owner</div>
			</div>
		</template>
		<template #list-title>
			<Row class="pa-4 items-center justify-between">
				<h5 class="fs-11 text-[#8B969D]">CHOOSE A SPACE ROLE</h5>
				<a target="_blank" :href="ROLES_AND_PERMISSIONS_LINK"> <AppIcon name="info" /> </a>
			</Row>
		</template>
		<template #list-item="{ item }">
			<div v-if="!item.divider">
				<MaybeUpgradeRequiredIndicator :billingFeatureId="item.billingFeatureId" v-if="item.billingFeatureId">
					<template #default="{ indicator, isUpgradeRequired }">
						<ProjectRoleSelectorItem
							:item="item"
							:indicator="indicator"
							:isUpgradeRequired="isUpgradeRequired"
							@click.native="
								() => onUpdateRole({ role: item.value, isUpgradeRequired, indicator, billingFeatureId: item.billingFeatureId })
							"
						/>
					</template>
				</MaybeUpgradeRequiredIndicator>
				<ProjectRoleSelectorItem v-else :item="item" />
			</div>
		</template>
	</AppDropdownMenu>
</template>

<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { ROLES_AND_PERMISSIONS_LINK } from '@/components/Billing/billing-service.const';
import ProjectRoleSelectorItem from '@/components/dialogs/projects/settings/tabs/DataRow/ProjectRoleSelectorItem.vue';
import { ROLE_MENU_OPTIONS, ADMIN, FULL_ROLE_OPTIONS } from '@/utils/projects.const';

export default {
	name: 'ProjectRoleSelectorDisplay',
	components: { MaybeUpgradeRequiredIndicator, ProjectRoleSelectorItem },
	props: {
		role: { type: String },
		disabled: { type: Boolean },
		showRemove: { type: Boolean, default: true },
	},
	methods: {
		onUpdateRole({ role, isUpgradeRequired, indicator, billingFeatureId }) {
			if (isUpgradeRequired && indicator?.setup && billingFeatureId) {
				indicator.setup().openUpgrade(null, billingFeatureId);
			} else {
				this.$emit('update:role', role);
			}
		},
	},
	computed: {
		selectedRole() {
			return this.items.find((x) => x.value === this.role)?.text;
		},
		items() {
			return (this.showRemove ? ROLE_MENU_OPTIONS : FULL_ROLE_OPTIONS).map((item) => {
				if (item.billingFeatureId) {
					return item;
				} else {
					const role = item.value || undefined;
					return { ...item, onClick: () => this.onUpdateRole({ role }) };
				}
			});
		},
	},
	created() {
		if (!this.role) {
			this.$emit('update:role', ADMIN);
		}
	},
	data() {
		return {
			ROLES_AND_PERMISSIONS_LINK,
		};
	},
};
</script>

<style scoped lang="scss">
.text {
	padding-top: 4px;
	font-size: 14px;
}
.subtext {
	margin-top: -4px;
	padding-bottom: 4px;
	font-size: 11px;
	color: #9e9e9e;
}
.disabled-description {
	font-size: 10px;
}
</style>
